module.exports = __webpack_public_path__ + "static/media/argentina.71b4134a.svg";